<template>
  <vue-draggable-resizable
    class="result-patients-panel"
    :class="{maximized}"
    :w="layout.w"
    :h="layout.h"
    :x="layout.x"
    :y="layout.y"
    classNameHandle="rsz-handle"
    :minWidth="400"
    :minHeight="200"
    :parent="true"
    :active="true"
    drag-handle=".top-bar"
  >
    <div class="top-bar">
      <div class="options">
        <div
          class="bar-title"
          :class="{ active: activeTab === 'meanValue' }"
          @click.stop="activate('meanValue')"
        >
          {{$t("histogram")}}
        </div>
        <div
          class="bar-title"
          :class="[{ active: activeTab === 'electrocardiography' }]"
          @click.stop="activate('electrocardiography')"
        >
          {{$t("ecg")}}
        </div>
        <div v-if="this.$store.state.paramsData.project.scenario != 'cardiosafe'"
          class="bar-title"
          :class="[{ active: activeTab === 'slices' }]"
          @click.stop="activate('slices')"
        >
          {{$t("slices")}}
        </div>
        <!-- TODO: fix this feature -->
        <!-- <div
          class="bar-title"
          :class="[{ active: activeTab === 'statistics' }]"
          @click.stop="activate('statistics')"
        >
          {{$t("statistics")}}
        </div> -->
      </div>
      <!-- <div :class="['toggle-button', {'open': activeTab !== null }]"></div> -->
      <div class="buttons">
        <div class="maximize-button" @click="maximized=!maximized"></div>
        <div class="close-button" @click="$emit('close')"></div>
      </div>
    </div>

    <div class="collapsible-container">
      <mean-values-panel
        v-if="activeTab === 'meanValue'"
        :caseList="caseList"
        :selectionList="selectionList"
        :mainGroup="mainGroup"
      ></mean-values-panel>
      <electrocardiography-panel
        v-if="activeTab === 'electrocardiography'"
        @highlight="onHighlight"
        :highlightedSubject="highlightedSubject"
        :data="selectionList"
      ></electrocardiography-panel>
      <slices-panel
        v-if="activeTab === 'slices'"
        :data="selectionList"
      ></slices-panel>
      <statistical-values-panel
        v-if="activeTab === 'statistics'"
        :groupsAndTrials="groupsAndTrials"
        :statisticalTestResults="statisticalTestResults"
        @statisticalAnalysisLoaded="updateStatisticalAnalysis"
      ></statistical-values-panel>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import MeanValuesPanel from '@/components/MeanValuesPanel'
import ElectrocardiographyPanel from '@/components/ElectrocardiographyPanel'
import SlicesPanel from '@/components/SlicesPanel'
import StatisticalValuesPanel from '@/components/StatisticalValuesPanel'
import VueDraggableResizable from 'vue-draggable-resizable'
import '@/styles/components/VueDraggableResizable.css'

export default {
  name: 'ResultsPatientsPanel',
  components: {MeanValuesPanel, ElectrocardiographyPanel, SlicesPanel, StatisticalValuesPanel, VueDraggableResizable},
  props: ['caseList', 'selectionList', 'layout', 'mainGroup', 'highlightedSubject', 'groupsAndTrials', 'statisticalTestResults'],
  model:{
    prop: 'highlightedSubject',
    event: 'change'
  },
  data () {
    return {
      activeTab: 'meanValue',
      maximized: false
    }
  },
  computed: {
  },
  methods: {
    onHighlight(d){
      console.log("EMITTING hightlihg change",d)
      this.$emit('change',d)
    },
    activate (val) {
      return this.activeTab = val
      // if (this.activeTab === val) {
      //   return this.activeTab = null
      // } else {
      //   return this.activeTab = val
      // }
    },
    updateStatisticalAnalysis(statisticalTestResults) {
      this.statisticalTestResults = statisticalTestResults
      this.$emit('statisticalAnalysisLoaded', statisticalTestResults)
    }
  }
}
</script>

<style lang="stylus" scoped>
.draggable
  border: none
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3)

  >>> .rsz-handle
    height: 20px
    opacity: 0
    width: 20px
    z-index 1
    // display none !important
    border: none;
    position: absolute;
    &.rsz-handle-br
      // display block !important
      bottom: 0;
      right: 0;
      width: 30px;
      height: 30px;
      background-color: transparent;
      opacity: 1;
      margin 10px
      m-icon("arrow-diagonal-down-right", 20)
    &.rsz-handle-bl
      display block !important
      bottom: 0;
      left: 0;
      width: 30px;
      height: 30px;
      background-color: transparent;
      opacity: 1;
      margin 10px
      m-icon("arrow-diagonal-down-right", 20)
      transform scale(-1,1)

    
  // ESTO NO VALE PARA EL "dropdown"...
  // >>> .collapsible-container
  //   overflow: hidden

.result-patients-panel
  display: flex
  flex-direction: column

  // height: 100%
  // width: 100%
  // height 450px !important
  // width: @height
  &.maximized
    width 100% !important
    height 100% !important
    transform translate(0,0) !important
      
  .top-bar
    align-items: center
    background-color: $charade
    color: #fff
    cursor: move
    display: flex
    // height: 40px
    flex: 0 0 40px;
    padding: 0 20px

    .options
      display: flex

      .bar-title
        cursor: pointer
        m-font-size(14, 20)
        opacity: 0.75
        position: relative

        &:not(:last-child)
          margin-right: 20px

        &:after
          background-color: $radical-red
          bottom: -10px
          content: ""
          height: 2px
          left: 0
          position: absolute
          transition: width 0.25s ease-in-out
          width: 0

        &:hover
          opacity: 1

        &.active
          cursor: default
          opacity: 1

          &:after
            width: 100%

        &.disabled
          cursor: not-allowed
          opacity: 0.5
          pointer-events: none
    .buttons
      margin-left: auto
      display flex
      .close-button
        cursor: pointer
        m-icon("cross", 16)
        
      .maximize-button
        cursor: pointer
        m-icon("fullscreen", 18)
        margin-right: 15px;
        
  .collapsible-container
    background: #303345
    color: #ffffff
    display: flex
    flex: 1 1 auto
    flex-direction: column
    height calc(100% - 40px)
    
    .mean-values-panel,
    .electrocardiography-panel
      flex: 1 1 auto
</style>